import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import IconButton from "../IconButton";
import { Survey } from ".";
import useUserMetadata from "../../hooks/useUserMetadata";
import Auth from "../../Auth";
import { mutate } from "swr";
import { SurveyModalContainer } from "./styles";
import { useLocation } from "react-router-dom";
import { AppEventPublisher } from "../../AppEventPublisher";

Modal.setAppElement("#root");

const SurveyModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const { userMetadata } = useUserMetadata();

  const handleComplete = async (survey) => {
    setIsOpen(false);
    await Auth.fetchWithIdToken("/api/user-metadata/survey", {
      survey,
    });
    await mutate("/api/user-metadata/get");
  };

  const handleSkip = async () => {
    handleComplete();
  };

  useEffect(() => {
    if (location.pathname === "/app/survey") {
      return;
    }

    if (userMetadata === undefined) {
      return;
    }

    const surveyCompleted = !!userMetadata?.survey?.completedAt;
    const shouldOpen = !surveyCompleted;

    if (shouldOpen) {
      AppEventPublisher.onboarding.oldSurveyModalViewed();
    }
    setIsOpen(shouldOpen);
  }, [location.pathname, userMetadata]);

  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          zIndex: "30000",
          width: "80vw",
          height: "80vh",
          maxWidth: "575px",
          maxHeight: "605px",
          transform: "translate(-50%, -50%)",
          border: "none",
          borderRadius: "20px",
          overflow: "hidden",
          background: "transparent",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.6)",
        },
      }}
    >
      <SurveyModalContainer>
        <div className="content">
          <div className="modal-header">
            <IconButton
              src="/assets/close.svg"
              onClick={handleSkip}
              className="close"
              ariaLabel={`Close modal`}
            />
          </div>
          <Survey
            showConsent
            onComplete={handleComplete}
            redirectAfterComplete={false}
          />
        </div>
      </SurveyModalContainer>
    </Modal>
  );
};

export default SurveyModal;
